<template>
  <div class="app-main" ref="appMain" tabindex="0">
    <!--<router-view></router-view>-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>


export default {
    name: 'App',
    mounted() {
        document.addEventListener('touchmove', function(event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        }, { passive: false });
    },
    beforeDestroy() {
        document.removeEventListener('touchmove', function(event) {
            if (event.touches.length > 1) {
                event.preventDefault();
            }
        }, { passive: false });
    }
}
</script>

<style lang="less">
body::-webkit-scrollbar {
    display: none;
}
// body {
// //   padding-top: env(safe-area-inset-top);
// //   padding-bottom: env(safe-area-inset-bottom);
// }
.employee-selector {
    .el-scrollbar {
        .el-select-dropdown__wrap {
            .el-select-dropdown__list {
                .el-select-dropdown__item {
                    padding: 0 8px;
                }
            }
        }
    }
}

.mission-status-input {
    .el-input__inner {
        padding: 0 8px!important;
    }
}

@media (max-width: 414px) {

    /* 只有在没有模态框显示时隐藏遮罩层 */
    body:not(.modal-open) /deep/ .v-modal {
        display: none;
    }

    html, body {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        overflow: hidden;
        overscroll-behavior: contain;
        // -webkit-overflow-scrolling: touch; /* 确保平滑滚动 */
    }
    body {
        -webkit-text-size-adjust: 100% !important;
        text-size-adjust: 100% !important;
        -moz-text-size-adjust: 100% !important;
        z-index: 1;
    }
    .app-main {
        // height: 100%!important;
        overflow: hidden;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        position: -ms-device-fixed;
        // position: -ms-page-fixed;
        // overflow-y: auto;
        // -webkit-overflow-scrolling: touch; /* 确保平滑滚动 */
        z-index: 2;
    }

    .el-message-box {
        width: 90%!important;
    }
}

.omit-line {
    display: -webkit-box; /* 必须设置display属性为-webkit-box */
    overflow: hidden; /* 超出部分隐藏 */
    text-overflow: ellipsis; /* 显示省略号 */
    -webkit-line-clamp: 1; /* 限制显示两行 */
    -webkit-box-orient: vertical; /* 垂直方向上的换行 */
}

@media (max-width: 480px) {
    .el-dialog__wrapper {
        background: rgba(0,0,0,0.6);
    }
}

.project-board-popper {
    padding: 0!important;
}

// .dialogClassActive {
//     .dialogClass {
//         width: 920px!important;
//     }
// }

.status-dropdown-item {
    display: flex;
    align-items: center;
    .dot {
        width: 12px;
        height: 12px;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        margin-right: 8px;
        .dot-dot {
            margin: 2px auto;
            width: 6px;
            height: 6px;
            border-radius: 6px 6px 6px 6px;
            opacity: 1;
        }
    }
    .dot-pause {
        border: 1px solid #CCCCCC;
        .dot-dot {
            border: 1px solid #CCCCCC;
        }
    }
    .dot-process {
        border: 1px solid #0A89FF;
        .dot-dot {
            border: 1px solid #0A89FF;
        }
    }
    .dot-complate {
        border: 1px solid #0BDC15;
        .dot-dot {
            border: 1px solid #0BDC15;
        }
    }
}

.app-main {
  height: 100vh;
}

.user-popover {
    padding-left: 0!important;
    padding-right: 0!important;
}

input::-webkit-outer-spin-button {
    -webkit-appearance: none;
}
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
input[type="number"] {
    -moz-appearance: textfield;
}

.select:not(.is-multiple)::after {
    display: none!important;
}


// @font-face{
//  font-family: 'CangErYuyangW05';
// src:url('https://oss.yf-gz.cn/file/1686911225025_314d6c3f2999e28235f3392f613b5ab2.ttf')format('truetype');
// font-weight:normal;
// font-style:normal;
// }
// @font-face{
// font-family:'CangErAndMoW04';
// src:url('https://oss.yf-gz.cn/file/1686911335493_62185c081bed8fc79717b1a8fdd9d8fa.ttf')format('truetype');
// font-weight:normal;
// font-style:normal;
// }
@font-face{
font-family:'Betta02';
src:url('https://oss.yf-gz.cn/file/1686911364829_3789719bbfd1dd206e5ce10ead61f9f7.ttf')format('truetype');
font-weight:normal;
font-style:normal;
}
// @font-face{
// font-family:'legendQIYiLu';
// src:url('https://oss.yf-gz.cn/file/1686911412834_a576a3b8a37ac9cfbda7c4f34c19e436.ttf')format('truetype');
// font-weight:normal;
// font-style:normal;
// }
</style>



// WEBPACK FOOTER //
// src/digitalHuman/app.vue